import styles from "./home.module.css";
import logo1 from "assets/images/logo (1).svg";
import logo from "assets/images/logo.svg";
import { FaTelegramPlane } from "react-icons/fa";
import { AiOutlineInstagram } from "react-icons/ai";
import footImg1 from "assets/images/moto.svg";
import footImg2 from "assets/images/mot.svg";
import footImg3 from "assets/images/motor.svg";
import footImg4 from "assets/images/motorr.svg";
import { BsTwitter } from "react-icons/bs";
function Footer() {
  return (
    <div className={`mt-5 ${styles.footConainer}`}>
      {/* <div className="row m-auto container ">
        <div className="col-lg-3 col-sm-6">
          <div className="d-flex flex-column text-center justify-content-center align-items-center my-3">
            <img src={footImg1} style={{ height: "100px" }} />
            <p className="my-3" style={{ fontSize: "14px" }}>
              ارسال فوری و رایگان
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="d-flex flex-column text-center justify-content-center align-items-center my-3">
            <img src={footImg2} style={{ height: "100px" }} />
            <p className="my-3" style={{ fontSize: "14px" }}>
              ضمانت اصل بودن کالا
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="d-flex flex-column text-center justify-content-center align-items-center my-3">
            <img src={footImg3} style={{ height: "100px" }} />
            <p className="my-3" style={{ fontSize: "14px" }}>
              پشتیبانی 24/7
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="d-flex flex-column text-center justify-content-center align-items-center my-3">
            <img src={footImg4} style={{ height: "100px" }} />
            <p className="my-3" style={{ fontSize: "14px" }}>
              پرداخت مطمئن
            </p>
          </div>
        </div>
      </div> */}{" "}
      <div
        className={`d-flex   justify-content-around mx-auto align-items-baseline flex-wrap ${styles.footConainers} ${styles.containerFooter}`}
      >
        <div className="text-center">کلیه حقوق سبدی محفوظ است.</div>
        {/* <div className={` d-flex flex-column pt-4   ${styles.widthFoot}`}>
          <div>
            <p className={styles.textHeadFoot}>سبدی</p>
            <div className={styles.divider}></div>
          </div>
          <p className={styles.textAFoot22}>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است،{" "}
          </p>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot2}`}>
          <div>
            <p className={styles.textHeadFoot}> پشتیبانی سبدی</p>
            <div className={styles.divider}></div>
          </div>

          <a className={styles.textAFoot}>تماس با ما</a>
          <a className={styles.textAFoot}>قوانین مقررات</a>
          <a className={styles.textAFoot}>سوالات متداول</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot2}`}>
          <div>
            <p className={styles.textHeadFoot}>لینک های سریع</p>
            <div className={styles.divider}></div>
          </div>

          <a className={styles.textAFoot}>سوالات متداول</a>
          <a className={styles.textAFoot}>انتقادات و پیشنهادات</a>
          <a className={styles.textAFoot}>قوانین و مقررات</a>
          <a className={styles.textAFoot}> حریم ‌خصوصی</a>
        </div>
        <div className={` d-flex flex-column pt-4  ${styles.widthFoot3}`}>
          <div>
            <p className={styles.textHeadFoot}>راهنمای خرید از سبدی</p>
            <div className={styles.divider}></div>
          </div>

          <a className={styles.textAFoot}>نحوه ثبت سفارش</a>
          <a className={styles.textAFoot}>رویه ارسال سفارش</a>
          <a className={styles.textAFoot}>شیوه های پرداخت</a>
        </div> */}

        <div
          className={` d-flex pt-4 flex-column text-center ${styles.widthFootTelegram}`}
        >
          <p className={styles.textPFoot}>ما را در فضای مجازی دنبال کنید</p>
          <div className="d-flex justify-content-center">
            <div className={styles.telegramDiv}>
              <FaTelegramPlane className={styles.telegramIcon} />
            </div>
            <div className={styles.telegramDiv}>
              <AiOutlineInstagram className={styles.telegramIcon} />
            </div>
            <div className={styles.telegramDiv}>
              <BsTwitter className={styles.telegramIcon} />
            </div>
          </div>
        </div>
        {/* <div
          className={` d-flex pt-2 pb-4 text-center ${styles.widthFootTelegram2}`}
        >
          <img src={logo1} alt="logo" className="mx-2" />
          <img src={logo} alt="logo2" className="mx-2" />
        </div> */}
      </div>
    </div>
  );
}

export default Footer;
